export const getRemoteIconPath = (remoteUrl, iconPath) => {
    const trimmedRemoteUrl = remoteUrl.endsWith('/')
        ? remoteUrl.slice(0, -1)
        : remoteUrl;
    const trimmedIconPath = iconPath.startsWith('/')
        ? iconPath.slice(1)
        : iconPath;
    return `${trimmedRemoteUrl}/${trimmedIconPath}`;
};
